<script lang="ts">
    import Vue from "vue";

    export default Vue.extend({
        props: {
            status: {
                type: String,
                required: false
            },
            size: {
                type: Number,
                required: false,
                default: 2
            }
        },
        methods: {
            emitShowConsistencyAnalysis()
            {
                this.$emit('show-consistency-analysis');
            }
        }
    });
</script>

<template>
    <div @click="emitShowConsistencyAnalysis">
        <template v-if="status === 'Unknown'">
            <span class="fa-stack fa-lg" title="Insufficient data to check consistency">
                <i class="fa fa-circle text-light" :class="`fa-stack-${size}x`"></i>
                <i class="fa-regular fa-circle" :class="`fa-stack-${size}x`"></i>
            </span>
        </template>

        <template v-if="status === 'Inconsistent'">
            <span class="fa-stack fa-lg" title="Inconsistencies detected">
                <i class="fa fa-circle text-danger" :class="`fa-stack-${size}x`"></i>
                <i class="fa-regular fa-face-frown" :class="`fa-stack-${size}x`"></i>
            </span>
        </template>

        <template v-if="status === 'Acceptable'" title="Consistency warning">
            <span class="fa-stack fa-lg">
                <i class="fa fa-circle text-warning" :class="`fa-stack-${size}x`"></i>
                <i class="fa-regular fa-face-meh" :class="`fa-stack-${size}x`"></i>
            </span>
        </template>

        <template v-if="status === 'Consistent'" title="Answers are consistent">
            <span class="fa-stack fa-lg">
                <i class="fa fa-circle text-success" :class="`fa-stack-${size}x`"></i>
                <i class="fa-regular fa-face-smile" :class="`fa-stack-${size}x`"></i>
            </span>
        </template>
    </div>
</template>